import { IPaths } from 'Shared/Core/ApiPath/IPaths';

export const BasicInfoApiPaths: IPaths = {
  AghsatHaghBimeh: {
    PayGhestHaghBimeh: 'AghsatHaghBimeh/PayGhestHaghBimeh',
    PayGhestHaghBimehCurrentUser: 'AghsatHaghBimeh/PayGhestHaghBimehCurrentUser',
    GetAghsatHaghBimehByCodeShenasehPardakht: 'AghsatHaghBimeh/GetAghsatHaghBimehByCodeShenasehPardakht',
    GetGhestHaghBimehPaymentDetail: 'AghsatHaghBimeh/GetGhestHaghBimehPaymentDetail',
    GetGhestHaghBimehPaymentDetailCurrentUser: 'AghsatHaghBimeh/GetGhestHaghBimehPaymentDetailCurrentUser',
    GetGhestHaghBimehPaymentDetailById: 'AghsatHaghBimeh/GetGhestHaghBimehPaymentDetailById',
    GetAllAghsatHaghBimehByShomarehBimehNameh: 'AghsatHaghBimeh/GetAllAghsatHaghBimehByShomarehBimehNameh',
    GetAllAghsatHaghBimehByShomarehBimehNamehCurrentUser:
      'AghsatHaghBimeh/GetAllAghsatHaghBimehByShomarehBimehNamehCurrentUser',
  },
  City: {
    GetActiveCities: 'City/GetActiveCities',
  },
  Province: {
    GetActiveProvinces: 'Province/GetActiveProvinces',
  },
  Country: {
    GetAllCountries: 'Country/GetActiveCountries',
  },
  Nesbat: {
    GetAllNesbatHa: 'Nesbat/GetActiveNesbatHa',
  },
  ParvandehHayeKhesarat: {
    GetAllParvandehHayeKhesarat: 'ParvandehKhesarat/GetAllParvandehHayeKhesarat',
    GetParvandehKhesaratByShomarehParvandeh: 'ParvandehKhesarat/GetParvandehKhesaratByShomarehParvandeh',
    GetAllParvandehHayeKhesaratCurrentUser: 'ParvandehKhesarat/GetAllParvandehHayeKhesaratCurrentUser',
    GetParvandehKhesaratByShomarehParvandehCurrentUser:
      'ParvandehKhesarat/GetParvandehKhesaratByShomarehParvandehCurrentUser',
  },
  HavalehHayeKhesarat: {
    GetAllHavalehHayeKhesarat: 'HavalehKhesarat/GetAllHavalehHayeKhesaratByShomarehParvandeh',
    GetHavalehKhesaratByShomarehHavaleh: 'HavalehKhesarat/GetHavalehKhesaratByShomarehHavaleh',
    GetAllHavalehHayeKhesaratByShomarehParvandehCurrentUser:
      'HavalehKhesarat/GetAllHavalehHayeKhesaratByShomarehParvandehCurrentUser',
    GetHavalehKhesaratByShomarehHavalehCurrentUser: 'HavalehKhesarat/GetHavalehKhesaratByShomarehHavalehCurrentUser',
  },
  NoeSherkatBimeh: {
    GetAllAnvaeSherkatBimeh: 'NoeSherkatBimeh/GetAllAnvaeSherkatBimeh',
  },
  AnvaeBimeh: {
    GetAllBimehNamehHaIcon: 'AnvaeBimeh/GetAllBimehNamehHaIcon',
  },
  TarhSodoor: {
    GetActiveTarhHayeSodoorByNoeBimeh: 'TarhSodoor/GetActiveTarhHayeSodoorByNoeBimeh',
  },
  KhatarEzafi: {
    GetActiveKhataratEzafi: 'KhatarEzafi/GetActiveKhataratEzafi',
  },
  Shoghl: {
    GetActiveShoghlHaByNoeBimehAndNoeTabaghehShoghli: 'Shoghl/GetActiveShoghlHaByNoeBimehAndNoeTabaghehShoghli',
  },
  TakhfifAdameKhesarat: {
    GetAllTakhfifHayeAdameKhesaratByNoeBimeh: 'TakhfifAdameKhesarat/GetActiveTakhfifHayeAdameKhesaratByNoeBimeh',
  },
  MarjaeDieh: {
    GetLastMarjaeDieh: 'MarjaeDieh/GetLastMarjaeDieh',
  },
  SodoorRule: {
    GetDefaultSodoorRule: 'SodoorRule/GetDefaultSodoorRule',
  },
  ClientModule: {
    GetAll: 'ClientModule/GetAll',
  },
  InsuranceModule: {
    GetAllInsuranceModules: 'InsuranceModule/GetAllInsuranceModules',
  },
  MenuCategory: {
    GetActiveMenuCategories: 'MenuCategory/GetActiveMenuCategories',
  },
  MenuContent: {
    GetMenuContentById: 'MenuContent/GetById',
    GetElhaghiyehMenuContents: 'MenuContent/GetElhaghiyehMenuContents',
  },
  InsuranceProductRule: {
    GetAll: 'InsuranceProductRule/GetAll',
  },
  Reminder: {
    CreateReminder: 'Reminder/CreateReminder',
    UpdateReminder: 'Reminder/UpdateReminder',
    DeleteReminder: 'Reminder/DeleteReminder',
    GetSendingReminders: 'Reminder/GetSendingReminders',
    GetRemindersByCurrentUserPagedFilter: 'Reminder/GetRemindersByCurrentUserPagedFilter',
    GetReminderById: 'Reminder/GetReminderById',
  },
  VahedBimeh: {
    GetAllVahedHayeBimehByNoeVahedBimehPagedFilter: 'VahedBimeh/GetAllVahedHayeBimehByNoeVahedBimehPagedFilter',
  },
  ModdatBimehNameh: {
    GetActiveModdatHayeBimehNameh: 'ModdatBimehNameh/GetActiveModdatHayeBimehNameh',
  },
  DiscountCode: {
    InquiryDiscountCode: 'DiscountCode/InquiryDiscountCodeBimehPasargad',
  },
};
